import React from 'react';
import cn from 'classnames';
import style from './content.mod.scss';
import Heading from '../heading/heading';
import Text from '../text/text';
import Container from '../layout/container/container';
import Divider from '../divider/divider';
import Button from '../button/button';
import Spacing from '../layout/spacing/spacing';
import { motion } from 'framer-motion';

const Content = ({
  heading,
  text,
  headingSize,
  side = 'left',
  internalLinkAnchor,
  anchor = false,
}) => {
  const classes = cn(style.content, {
    [style[`content--${side}`]]: side,
  });

  const headingVariants = {
    offscreen: {
      x: -150,
      opacity: 0,
    },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        bounce: 0.2,
        duration: 0.7,
        delay: 0.15,
      },
    },
  };

  const contentVariants = {
    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
      transition: {
        duration: 1,
        delay: 0.2,
      },
    },
  };

  const handleClick = (e) => {
    e.preventDefault();

    const targetElement = document.getElementById(internalLinkAnchor);
    if (targetElement) {
      // Select the mobile menu element by its class name

      // Only apply the offset if we're on mobile and the menu is open
      const headerOffset = 10;

      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    //create div and add id if anchor exists
    <div id={anchor ? anchor : null}>
      <Container size="xl">
        <Divider />

        <div className={classes}>
          {heading && (
            <motion.div
              variants={contentVariants}
              initial="offscreen"
              whileInView="onscreen"
              viewport={{ once: true, amount: 0.1 }}
            >
              <div className={style.content__heading}>
                <Heading text={heading} tag={2} size={headingSize} />
              </div>
            </motion.div>
          )}
          <motion.div
            variants={contentVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.1 }}
          >
            <div className={style.content__text}>
              <Text html={text} />
              {internalLinkAnchor && (
                <Spacing pt={1}>
                  <Button
                    type="button"
                    to={`#${internalLinkAnchor}`}
                    onClick={handleClick}
                    text="Get in touch"
                  />
                </Spacing>
              )}
            </div>
          </motion.div>
        </div>
      </Container>
    </div>
  );
};

export default Content;
